import { render } from "./Ai247Explanation.vue?vue&type=template&id=2c3764e7&ts=true"
import script from "./Ai247Explanation.vue?vue&type=script&lang=ts"
export * from "./Ai247Explanation.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__